module.exports = __webpack_public_path__ + "static/img/Latu-Fainu.6ee99ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Latu-Fainu.jpg
// module id = QkdW
// module chunks = 0